import { failure, validCommand } from '../domain/daily-routine.ts';
import type { CheckView, SetCheckCommand, TimeStamp } from '../domain/daily-routine.ts';
import type { DailyRoutineRepository } from '../ports/daily-routine-repository.ts';

export interface IntentSource { operationId(): string; time(): TimeStamp }
export class DailyRoutine {
  constructor(private readonly repository: DailyRoutineRepository, private readonly source: IntentSource) {}
  read(checkId: string) { return this.repository.readCheck(checkId); }
  intend(view: CheckView, desiredState: boolean): SetCheckCommand {
    return { operationId: this.source.operationId(), checkId: view.check.checkId, itemId: view.check.itemId,
      localDate: view.check.localDate, desiredState, expectedRevision: view.check.revision,
      context: { ...view.context }, ...this.source.time() };
  }
  async execute(command: SetCheckCommand) {
    if (!validCommand(command)) return failure('VALIDATION_ERROR');
    return this.repository.setCheck(command);
  }
}
